// extracted by mini-css-extract-plugin
module.exports = {"heading":"style__heading___2dqtH","summary":"style__summary___1Srnv"};